import { Injectable } from '@angular/core';
import { ColumnForSelection } from '../import/column-for-selection';

import { DataService } from '../network/data.service';
import { PreaggregationCheckResult } from './preaggregation-check-result';
import { PreaggregationStrategy } from './preaggregation-strategy';

@Injectable()
export class PreaggregationSevice {

    constructor(private dataService: DataService) {
    }

    public async requiresPreaggregation(projectId: string): Promise<boolean> {
         return (await this.getPreaggregationCheckResult(projectId)).requiresPreaggregation;
    }

    public getPreaggregationCheckResult(projectId: string): Promise<PreaggregationCheckResult> {
        return this.dataService.get<PreaggregationCheckResult>('processing/checkForPreaggregation/' + projectId);
    }

    public savePreaggregationStrategy(projectId: string, selectedStrategy: PreaggregationStrategy, columns: ColumnForSelection[]) {
        let weightColumnIndex: number;
        let columnIndexes: number[];
        if (selectedStrategy == PreaggregationStrategy.averageAndSum) {
            for (let i = 0; i < columns.length; ++i) {
                if (columns[i].isSelected) {
                    weightColumnIndex = i;
                    break;
                }
            }
            columnIndexes = [];
            for (let i = 0; i < columns.length; ++i) {
                if (columns[i].isSelected) {
                    columnIndexes.push(i);
                }
            }
        }
        return this.dataService.post('processing/savePreaggregationStrategy', {
            projectId: projectId,
            selectedStrategy: PreaggregationStrategy[selectedStrategy],
            weightColumnIndex: weightColumnIndex,
            columnIndexes: columnIndexes,
        });
    }
}